import { render, staticRenderFns } from "./EvalQuestion.vue?vue&type=template&id=3b128d45&scoped=true&"
import script from "./EvalQuestion.vue?vue&type=script&lang=js&"
export * from "./EvalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EvalQuestion.vue?vue&type=style&index=0&id=3b128d45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b128d45",
  null
  
)

export default component.exports